import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M11.6274 11.3787C10.0588 11.3787 9 10.2868 9 8.66912C9 7.21324 10.2157 6 11.8627 6C13.6667 6 15 7.45588 15 9.68015C15 14.7353 11.3137 16.7574 9 17V14.7757C10.5686 14.4926 12.3333 12.9154 12.4118 11.1765C12.3333 11.2169 12.0196 11.3787 11.6274 11.3787Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "SingleQuotesR"
);
